import React, { PureComponent, ComponentProps } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { CalendarIcon } from '@components/Icons'
import { TextInput } from '@components/FormInputs/TextInput'
import {
  DatePickerInputWrapper,
  inputStyles,
  calendarIconStyles
} from './DatePickerInput.elements'

type Props = Partial<ComponentProps<typeof TextInput>> & {
  hasError: boolean
}

export class DatePickerInput extends PureComponent<Props> {
  render() {
    const { value, hasError, id, onChange, ref, ...restProps } = this.props

    const handleChange = (_name: string, value: string) => {
      // @ts-ignore
      onChange && onChange(value)
    }

    return (
      <DatePickerInputWrapper>
        <TextInput
          {...restProps}
          id={id}
          name=""
          type="text"
          value={value as string}
          onChange={handleChange}
          error={!!hasError}
          css={inputStyles}
        />
        <CalendarIcon css={calendarIconStyles} />
      </DatePickerInputWrapper>
    )
  }
}
